import React, { useEffect } from "react";
import { useTranslation } from "@/translations/TranslationContext";

function Form() {
  const { t } = useTranslation();
  
  useEffect(() => {
    // Load Calendly script when component mounts
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up script when component unmounts
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <div className="contactform">
        <h3>{t.contact.form.title}</h3>
        <div className="calendly-inline-widget" 
          data-url="https://calendly.com/oussama-hentabli/introduction" 
          style={{ minWidth: '320px', height: '830px' }}>
        </div>
      </div>
    </>
  );
}

export default Form;
